import {brandConfigObjectMap} from "@/brand/brandConfig";

export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8080', getBrandConfig('vc-za-btj'));
brandConfigMap.set('https://quiz-prelude.beatthejams.co.za', getBrandConfig('vc-za-btj'));

export function getBrandConfig(brand) {
    const brandConfigObject = brandConfigObjectMap.get(brand);
    return {
        brand,
        gameTitle: brandConfigObject.gameTitle,
        baseRoute: brandConfigObject.baseRoute,
        webMarketingUrl: brandConfigObject.webMarketingUrl,
        gameUrl: brandConfigObject.gameUrl,
        gtmIdentifier: brandConfigObject.gtmIdentifier,
    }
}
